export const getInitials = (fullName: string | undefined) => {
  return fullName
    ? fullName
        .split(" ")
        .map((n) => n[0])
        .join("")
    : "?";
};
